import Vue from 'vue/dist/vue.js'
import Vuesax from 'vuesax'
Vue.use(Vuesax)


export default Vue.extend({
  template: `
        <!--
        <span>
            <button 
            style="
                height: 20px; 
                line-height: 0.5;
            " 
            v-on:click="invokeParentMethodEditDataClient" 
            class="btn btn-info"
            >
                Editar Datos
            </button>

            <button 
            style="
                height: 20px; 
                line-height: 0.5;
            " 
            v-on:click="invokeParentMethodChangeInmigration" 
            class="btn btn-info"
            >
                Agregar Extranjería
            </button>

            <button 
            style="
                height: 20px; 
                line-height: 0.5;
            " 
            v-on:click="invokeParentMethodRemoveInmigration" 
            class="btn btn-info"
            >
                Remove Inmigration
            </button>

            <button 
            style="
                height: 20px; 
                line-height: 0.5;
            " 
            v-on:click="invokeParentMethodChangePassword" 
            class="btn btn-info"
            >
                Password
            </button>

            <button 
            style="
                height: 20px; 
                line-height: 0.5;
            " 
            v-on:click="invokeParentMethodChangeAdvisor" 
            class="btn btn-info"
            >
                Cambiar Asesor
            </button>

        </span>
        -->
        
        <div class="flex">
            <vs-button title="Editar datos" class="mr-1" color="primary" type="border" icon-pack="feather" icon="icon-edit" v-on:click="invokeParentMethodEditDataClient"></vs-button>

            <vs-button title="Agregar Extranjería" class="mr-1" color="primary" type="border" icon-pack="feather" icon="icon-flag" v-on:click="invokeParentMethodChangeInmigration"></vs-button>

            <vs-button title="Remover Extranjería" class="mr-1" color="primary" type="border" icon-pack="feather" icon="icon-x" v-on:click="invokeParentMethodRemoveInmigration"></vs-button>

            <vs-button title="Cambiar password" class="mr-1" color="primary" type="border" icon-pack="feather" icon="icon-lock" v-on:click="invokeParentMethodChangePassword"></vs-button>

            <vs-button title="Cambiar asesor" class="mr-0" color="primary" type="border" icon-pack="feather" icon="icon-shield" v-on:click="invokeParentMethodChangeAdvisor"></vs-button>
        </div>
        
        
    `,
  data () {
    return {}
  },
  components: {},
  beforeMount () {},
  mounted () {},
  methods: {
    /// you can add your html icon logic in template and call function herelike onIconClick()
    invokeParentMethodEditDataClient () {
      this.params.context.componentParent.editDataClient(this.params.data)
    },
    invokeParentMethodChangeInmigration () {
      this.params.context.componentParent.changeInmigrationService(this.params.data)
    },
    invokeParentMethodRemoveInmigration () {
      this.params.context.componentParent.openModalRemoveInmigration(this.params.data)
    },
    invokeParentMethodChangePassword () {
      this.params.context.componentParent.openModalChangePassword(this.params.data)
    },
    invokeParentMethodChangeAdvisor () {
      this.params.context.componentParent.openModalChangeAdvisor(this.params.data)
    }
  }
})